import { View } from 'react-native';

import { LegalSection } from '@/components/domain/LegalSection';
import { BoundedScrollView } from '@/components/ui/BoundedScrollView';
import { NavBar } from '@/components/ui/NavBar';
import { Screen } from '@/components/ui/Screen';
import { Text } from '@/components/ui/Text';
import { useGoBack } from '@/lib/navigation';

const SECTIONS = [
  {
    index: '01',
    label: 'What we store',
    body: 'Your account email, the templates you build, and the history of runs you complete. Authentication is handled by Supabase; we never see your password.',
  },
  {
    index: '02',
    label: 'How we use it',
    body: 'To sync your work across devices, power live shared runs, and keep a sealed record of what was checked, when, and by whom.',
  },
  {
    index: '03',
    label: 'Sharing',
    body: "We don't sell your data or show ads. Run data is visible only to people you invite to that run.",
  },
  {
    index: '04',
    label: 'Your control',
    body: 'Export everything or delete your account at any time from Settings. Deletion removes your templates and logs from our systems within 30 days.',
  },
];

export default function PrivacyScreen() {
  const goBack = useGoBack('/');
  return (
    <Screen edges={['top']}>
      <NavBar onBack={goBack} title="Privacy Policy" />
      <BoundedScrollView contentContainerClassName="gap-5 px-5 pb-10 pt-2">
        <Text variant="accent">Updated May 2026</Text>
        {SECTIONS.map((s) => (
          <LegalSection key={s.index} {...s} />
        ))}
        <View className="h-4" />
      </BoundedScrollView>
    </Screen>
  );
}
